// extracted by mini-css-extract-plugin
module.exports = {"popup":"Modal_popup__0brXd","overlay":"Modal_overlay__nbJY5","inner":"Modal_inner__XIYx3","close":"Modal_close__AOA14","xs":"Modal_xs__Dhi8P"};